import { render } from "./BookCardOverlay.vue?vue&type=template&id=7326c5c6&scoped=true"
import script from "./BookCardOverlay.vue?vue&type=script&lang=js"
export * from "./BookCardOverlay.vue?vue&type=script&lang=js"

import "./BookCardOverlay.vue?vue&type=style&index=0&id=7326c5c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7326c5c6"]])

export default __exports__